import { axiosPost } from '../../axios/axios.js'

export const requestActionsCancelAssignment = {
  methods: {
    onCancelAssignment: function (onSuccessApply) {
      this.askCancelAssignment(props => {
        this.cancelExecutorAssignment(props)
          .then(() => {
            if (onSuccessApply) {
              onSuccessApply()
            }
          })
      })
    },
    askCancelAssignment: function (onApply) {
      let message
      if (this.request.assignedBrigade) {
        message = 'Отменить назначение бригады "' + this.request.executorName + '"?'
      } else {
        message = 'Отменить назначение исполнителя ' + this.request.executorName + '?'
      }

      const taskStatus = this.request.bpStateId // используется taskStatus, чтобы было проще искать похожую логику по коду
      const warnings = taskStatus === 'BS4' ? ['Активный отчёт об исполнении работ будет удален'] : null
      const askCancelBrigadeAutoAssignment = this.request.assignedBrigade && this.request.autoAssign

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes' || action === 'ok') {
            let props
            if (askCancelBrigadeAutoAssignment) {
              props = { cancelAppointmentAction: action === 'yes' ? 'cancelAutoAssign' : 'exceptBrigade' }
            } else {
              props = { cancelAppointmentAction: 'none' }
            }
            if (taskStatus === 'BS4') {
              props.reportDeletionConfirmed = true
            }
            onApply(props)
          }
        },
        header: message,
        buttons: askCancelBrigadeAutoAssignment ? {
          yes: 'Да и отключить авто',
          ok: 'Да и исключить бригаду из авто по данной заявке',
          no: 'Нет'
        } : {
          yes: 'Да',
          no: 'Нет'
        },
        warning: warnings
      })
    },
    cancelExecutorAssignment: function (props) {
      const bodyFormData = new FormData()
      bodyFormData.set('requestId', this.request.bpContextId)

      if (props != null) {
        for (var key in props) {
          bodyFormData.append(key, props[key])
        }
      }

      return axiosPost({
        url: '/service/delta/request/cancelAssignment',
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Назначение отменено',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          const errMsg = response.message || 'Ошибка отмены назначения'
          this.$q.notify({
            type: 'negative',
            message: errMsg,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(errMsg))
        },
        throws: true
      })
    }
  }
}
